module.exports = __webpack_public_path__ + "img/illust1-2x.7879b549.png";